import React from "react";
import { Formik, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,

} from "../Styles/InputStyles";
import DropzoneImageUpload from "./DropzoneImageUpload";

const SupportingDocument = ({ addAssetFunctionMutate, setSelectedForm, isaddAssetLoading, setFormData, formData, }) => {
    const initialValues = {
        invoice: "",
        warranty: "",
    };
    const handleBack = () => {
        setSelectedForm("2");
    }

    const handleSubmit = (values) => {

        const updatedFormData = {
            ...formData,
            supportingDocument: values,
        };

        setFormData(updatedFormData);
        addAssetFunctionMutate(updatedFormData);

    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
                <Form>
                    <ModalSubHeading>Step 3</ModalSubHeading>
                    <ModalHeading>Supporting Documents Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="invoice">
                                    Upload Invoice
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => setFieldValue("invoice", file)}
                                        componentFor="invoice"
                                    />
                                </div>
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="warrenty">
                                    Warranty Document
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => setFieldValue("warranty", file)}
                                        componentFor="warranty"
                                    />
                                </div>
                            </InputGroup>

                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handleBack}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit" disabled={isaddAssetLoading}>
                            {isaddAssetLoading ? "Submitting..." : "Submit"}
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};

export default SupportingDocument;